import React from 'react';
import PageHeader from '../components/PageHeader';
import './PageHeaderLayout.less';

export default ({ children, className, ...rest }) => (
  <div className="page-header-layout">
    <PageHeader key="pageheader" {...rest} />
    {children && <div className={`content ${className}`}>{children}</div>}
  </div>
);



// WEBPACK FOOTER //
// ./src/layouts/PageHeaderLayout.js